/**
 * `?notice=unavailable` (spec §4.6, K-9): "Our events site is updating. Please try again in a minute."
 * Shown client-side, then cleared from the address bar (the other parameters, `e` included, stay).
 */
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Info } from "lucide-react";

export const MESSAGES = {
  unavailable: "Our events site is updating. Please try again in a minute.",
};

export function Notice() {
  const [params, setParams] = useSearchParams();
  const key = params.get("notice");
  const [text, setText] = useState(() => (key && MESSAGES[key]) || null);
  useEffect(() => {
    if (!key) return;
    if (MESSAGES[key]) setText(MESSAGES[key]);
    const next = new URLSearchParams(params);
    next.delete("notice");
    setParams(next, { replace: true });
  }, [key]); // eslint-disable-line
  if (!text) return null;
  return (
    <div className="ev-wrap ev-notice" role="status">
      <div className="ev-up"><Info size={18} aria-hidden="true" className="ev-notice-mark" /><span>{text}</span></div>
    </div>
  );
}
